import script from "./OTPForm.vue?vue&type=script&setup=true&lang=js"
export * from "./OTPForm.vue?vue&type=script&setup=true&lang=js"

import "./OTPForm.vue?vue&type=style&index=0&id=51b0dc02&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51b0dc02"]])

export default __exports__